import { useQuery } from '../use-query'
import type { UseQuerySwrOptions } from '../use-query'
import type { CmsPage, Maybe } from '@pylot-data/fwrdschema'
import { RequestInit } from '@vercel/fetch'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { getCMSPageQuery } from '../../api/operations/graphql/getCMSPageQuery'
import { useSmoothCmsContent } from './use-smooth-cms-content'

export type CmsPageResponse = {
    cmsPage?: Maybe<CmsPage>
    isValidating: boolean
    error?: GraphQLError
}

export const useCmsPage = (
    identifier: string,
    swrOptions?: UseQuerySwrOptions,
    fetchOptions?: RequestInit
): CmsPageResponse => {
    const { data, error, isValidating } = useQuery<
        { identifier: string },
        { cmsPage: CmsPage }
    >(getCMSPageQuery, { identifier }, swrOptions, {
        method: 'POST',
        cache: 'no-store',
        ...fetchOptions
    })

    useSmoothCmsContent()

    return {
        cmsPage: data?.data?.cmsPage,
        isValidating,
        error
    }
}
